import FeatureGateRoute from './FeatureGateRoute';

export default FeatureGateRoute;
